import React, { ReactNode } from "react";
import "./PageDetail.scss";

interface PageBandProps {
  /** The band's `h1` — a page name, or the sidenav section when the shell renders the band. */
  title: string;
  /** Secondary line under the title (the shell's "Hello, …" greeting). */
  subtitle?: ReactNode;
  /** Trail rendered under the title. Pass whichever breadcrumb component the route needs. */
  breadcrumbs?: ReactNode;
  /** Right-hand slot for page-level controls that belong on the banner. */
  actions?: ReactNode;
  /** Adds the extra top margin the impersonation banner needs. */
  impersonating?: boolean;
  /** Loosens the title's bottom margin on screens without a breadcrumb trail. */
  homeActive?: boolean;
}

/**
 * The brown page banner — the single source for that chrome.
 *
 * `PageDetail` renders it for every shell route, and routes the shell skips (App.tsx's
 * `hidePageDetail`) render it themselves with their own title, trail, and controls. Keeping one
 * component means the background, heights, and overlap can't drift per feature — the reason the
 * Workflow Library and PostIF bands previously duplicated `PageDetail.scss` by hand.
 */
const PageBand: React.FC<PageBandProps> = ({
  title,
  subtitle,
  breadcrumbs,
  actions,
  impersonating = false,
  homeActive = false,
}) => (
  <div className="page-detail">
    <div className={`page-detail-content ${impersonating ? "impersonating" : ""}`}>
      <div className={`page-detail-left ${homeActive ? "home-active" : ""}`}>
        <div>
          <h1>{title}</h1>
          {subtitle}
          {breadcrumbs && <div className="breadcrumbs">{breadcrumbs}</div>}
        </div>
      </div>

      {actions && <div className="page-detail-actions">{actions}</div>}
    </div>
  </div>
);

export default PageBand;
